<template>
  <div class="spoiler" :class="{isActive: isActive }">
    <button
      class="spoiler__title"
      @click="$emit('toggleSpoiler')"
    >
      <slot name="title" :item="item">
        {{item.label}}
        <IconDef
          name="spoiler-arrow"
        />
      </slot>
    </button>
    <div class="spoiler__content">
      <div>
        <slot name="content">
          {{item.content}}
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import IconDef from "~/components/UI/IconDef.vue";
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  index: {
    type: String
  }
})

</script>
